

































import AwardInfoComponent from "./AwardInfoComponent.vue"
import RecipientInfoComponent from "./RecipientInfoComponent.vue"
import AwardListComponent from "./AwardListComponent.vue"
import ICategory from "../models/category";
import {defineComponent, onMounted, PropType} from "@vue/composition-api";
import {useActions, useMutations, useState} from "vuex-composition-helpers";
import RecipientImageComponent from "@/apps/AwardsWidget/components/RecipientImageComponent.vue";
import InfiniteScrollTrigger from "@/shared/components/InfiniteScrollTrigger.vue";
import HeadingAtom from "@/shared/components/atoms/HeadingAtom.vue";

export default defineComponent({
  name: "AwardsWidget",
  components: {
    AwardListComponent,
    AwardInfoComponent,
    RecipientInfoComponent,
    RecipientImageComponent,
    InfiniteScrollTrigger,
    HeadingAtom
  },
  props: {
    title: {type: String},
    categories: {type: [] as PropType<ICategory[]>, required: true}
  },
  setup: (props) => {
    const {setCategories, loadMoreRecipients} = useMutations(['setCategories', 'loadMoreRecipients']);
    const {selectedCategory, recipientsLimit} = useState(['selectedCategory', 'recipientsLimit']);
    const {init} = useActions(['init']);
    setCategories(props.categories);

    onMounted(async () => {
      await init(props.categories);
    })

    return {
      selectedCategory,
      loadMoreRecipients,
      recipientsLimit
    }
  }
})
